import TabStackLayout from '@/views/layouts/TabStackLayout'

export default function TradeLayout() {
  return <TabStackLayout title="收款" />
}
